import { createSlice } from '@reduxjs/toolkit';
import { ITimesheetLock } from '../../../../dto';
import { setTimesheetLock } from '../actions';
import { MN_TIMESHEET_LOCK, TYPE_ELEMENT } from '../../../../common';

export interface TimesheetLockState {
  data: ITimesheetLock | null;
  loading: boolean;
  error: string | null;
}

const initialState: TimesheetLockState = {
  data: null,
  loading: false,
  error: null,
};

export const timesheetLockSlice = createSlice({
  name: `${MN_TIMESHEET_LOCK}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setTimesheetLock, (state, { payload }) => {
      state.data = payload;
    });
  },
});
